<div style="height: 100px">
  <h3>Filter</h3>
  <shop-view-filter (change)="data.doChange()" (viewChange)="data.view.next($event)" [view]="data.view|async"
                    [viewcomp]="data"></shop-view-filter>
</div>
